import { createContext } from 'react';

import type { PreviewContextValue, PreviewManagerContextValue } from './Preview.types';

const initialMethods = {
  updatePreview: () => {},
  unmountPreview: () => {}
};

export const initialPreviewContext: PreviewContextValue = {
  initialized: false,
  previewTriggerRef: { current: null },
  ...initialMethods
};

export const PreviewContext = createContext<PreviewContextValue>(initialPreviewContext);

export const PreviewManagerContext = createContext<PreviewManagerContextValue>({
  createPreview: () => initialMethods,
  PreviewContext,
  initialized: false,
  previewActive: false,
  setPreviewActive: () => {}
});
